export enum PaymentType {
   ON_SITE = 'ON_SITE',
   STRIPE_PAYMENT = 'STRIPE_PAYMENT',
}
